/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Row4_KbInputs */

const en_mk_cmp_row4_kb = /** @type {(inputs: Mk_Cmp_Row4_KbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One place — channels, DMs, and agents`)
};

const id_mk_cmp_row4_kb = /** @type {(inputs: Mk_Cmp_Row4_KbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu tempat — channel, DM, dan agen`)
};

/**
* | output |
* | --- |
* | "One place — channels, DMs, and agents" |
*
* @param {Mk_Cmp_Row4_KbInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_row4_kb = /** @type {((inputs?: Mk_Cmp_Row4_KbInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Row4_KbInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_row4_kb(inputs)
	return en_mk_cmp_row4_kb(inputs)
});